module.exports = __webpack_public_path__ + "media/images/vp/parallax.new.04.a-30f833f5a2c86d5c3b405cd4e7049cee.svg";